"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitPaneWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("react-science/ui");
const PreferencesContext_1 = require("../context/PreferencesContext");
function SplitPaneWrapper({ children }) {
    const { current, dispatch } = (0, PreferencesContext_1.usePreferences)();
    const { general: { verticalSplitterPosition, verticalSplitterCloseThreshold }, display: { general = {} }, } = current;
    function resizeHandler(value) {
        dispatch({
            type: 'SET_VERTICAL_SPLITTER_POSITION',
            payload: {
                value,
            },
        });
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.SplitPane, { size: verticalSplitterPosition, direction: "horizontal", controlledSide: "end", closed: general?.hidePanelOnLoad ? true : verticalSplitterCloseThreshold, onResize: resizeHandler, children: children }));
}
exports.SplitPaneWrapper = SplitPaneWrapper;
